export default __webpack_public_path__ + "static/banner-renovation-hiring-builder-f3a9f284262148a1a7aa1d49b1ad2bf2.jpg";